import { render, staticRenderFns } from "./bulkImport.vue?vue&type=template&id=5590ad2d&scoped=true"
import script from "./bulkImport.vue?vue&type=script&lang=js"
export * from "./bulkImport.vue?vue&type=script&lang=js"
import style0 from "./bulkImport.vue?vue&type=style&index=0&id=5590ad2d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5590ad2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5590ad2d')) {
      api.createRecord('5590ad2d', component.options)
    } else {
      api.reload('5590ad2d', component.options)
    }
    module.hot.accept("./bulkImport.vue?vue&type=template&id=5590ad2d&scoped=true", function () {
      api.rerender('5590ad2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/route/trunkLineManagement/component/bulkImport.vue"
export default component.exports